<template>
  <div class="bigbox cursorstyle">
    <div class="newtopbox" style="margin-top: 2vh;">
      <div class="newtopboxLeft">
        <div class="topbox cursorstyleObjBtn">
          <div :class="this.ContentitemListBtntype == 0? 'divSelect':''" @click="ContentitemListBtn(0)">
            待转化
          </div>
          <div :class="this.ContentitemListBtntype == 1? 'divSelect':''" @click="ContentitemListBtn(1)">
            已转化
          </div>
          <span style="float: right; font-size: 0.87rem; color: #333333; font-weight: 400;"
                @click="AchievementsMores('conversion')">查看更多>></span>
        </div>
        <div class="bodeContent">
          <div class="Contentitembox" v-for="(item,index) in ContentitemList" :key="index">
            <div class="Contentitemboximg">
              <img v-if="item.achievement_pictures[0]" :src="item.achievement_pictures[0].url">
            </div>
            <div class="ContentitemboxText">
              <div class="ContentitemboxText_name cursorstyle" :title="item.name">
                发明名称：{{item.name}}
              </div>
              <div class="cursorstyle">
                所属地区：{{item.achievement_address}}
              </div>
              <div class="cursorstyle" v-if="item.achievement_status == 0">
                拟转化金额：<span style="color: #C81616 ;">
									<span v-if="item.achievement_is_face == '0' && item.achievement_amount == ''">面议</span>
									<span v-else>	{{ item.achievement_amount }}</span>
								</span>
              </div>




            </div>
            <div class="ContentitemboxBottom cursorstyleObjBtn "
                 @click="AchievementsDetails({path:'conversion',item:item})">
              查看详情>>
            </div>
          </div>
        </div>
      </div>
      <div class="newtopboxright">
        <div >
          <div class="newtopboxrighttop" style="height:3.8vh; line-height:3.8vh; background: #F6F6F6;">
            <div>
              <span style="margin-left: 10px">  通知公告</span>
               <span @click="AchievementsMores('notice')"  style="float: right; margin-right: 10px; font-size: 0.87rem; color: #333333; font-weight: 400;">查看更多</span>
            </div>
          </div>
          <div class="" style="height: 90%; ">
            <template>
              <el-table :data="informationList" style="width: 100%;height: 100%;"
                        :row-class-name="tableRowClassName" @row-click="openDetails">
                <el-table-column type="index" label="序号" show-overflow-tooltip width="50"
                                 align="center">
                </el-table-column>
                <el-table-column prop="name" label="标题" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="create_time" label="发布时间" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="view_count" label="浏览次数" show-overflow-tooltip
                                 align="center">
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
        <div class="" style="width: 100%;">
          <div  class="newtopboxrighttop" style="height: 3.9vh; line-height:3.8vh; background: #F6F6F6;" >
            <div class="" style=" color: #333333; ">
              <span style="margin-left: 10px">推介会</span>
              <span @click="AchievementsMores('Recommend')"  style="float: right; margin-right: 10px; font-size: 0.87rem; color: #333333; font-weight: 400;">查看更多</span>

            </div>
          </div>
          <div class="" style="height: 90%;">
            <template>
              <el-table :data="PromotionMeeting" style="width: 100%;height: 100%;"
                        :row-class-name="tableRowClassName" @row-click="openDetails">
                <el-table-column type="index" label="序号" show-overflow-tooltip width="50"
                                 align="center">
                </el-table-column>
                <el-table-column prop="name" label="会议名称" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="create_time" label="发布日期" show-overflow-tooltip align="center">
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="" style="font-weight: bold;font-size: 18px; color: #333333; margin-top: 2vh;">
      <span>商家名录</span>
      <span class="cursorstyleObjBtn" style="float: right; font-size: 0.87rem; color: #333333; font-weight: 400;"
            @click="AchievementsMores('business')">查看更多>></span>
    </div>
    <div class="bigitembox">
      <div class="" style="width: 100%;">
        <template>
          <el-table :data="enterpriseList" style="width: 100%" :row-class-name="tableRowClassName" @row-click="openDetailsEnterpise">
            <el-table-column type="index" label="序号" show-overflow-tooltip width="50" align="center">
            </el-table-column>
            <el-table-column prop="name" label="商家名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="register_address" label="所属地区" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="desc" label="商家介绍" show-overflow-tooltip align="center">
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import {
  // 商家名录
  enterpriseList,
  // 通知公告
  informationList,
  // 转化列表

} from '@/api/Achievements.js'
// 转化列表
import{auditList}from"@/api/home.js"
// 推介会
import {
  GetlistinformationInterface
} from "@/api/ApplicationManagement.js"
export default {
  data() {
    return {
      // 转化列表
      ContentitemList: [

      ],
      //转化列表状态
      ContentitemListBtntype: 0,
      // 通知公告列表
      informationList: [],
      // 商家名录
      enterpriseList: [],
      // 推介会
      PromotionMeeting: []
    }
  },
  mounted() {
    this.achievementLists(0)
    this.informationLists()
    this.enterpriseLists()
    this.PromotionMeetings()
  },
  methods: {
    openDetailsEnterpise(row){
      this.$router.push({path:'./enterpriseDetail',query:{type:0,ids:row.id}})
    },
    // 切换带转化和已转化的列表
    ContentitemListBtn(val) {
      this.ContentitemListBtntype = val
      this.achievementLists(val)
    },
    // 转化列表
    async achievementLists(val) {
      let obj = {
        achievement_status: this.ContentitemListBtntype,
        byok:1
      }
      let res = await auditList(obj)
      if (res.code == '00000') {
        // let reslist = res.data.result.map((item,index)=>{

        // 	if(item.achievement_pictures&&item.achievement_pictures.length>0){
        // 		item.achievement_pictures = item.achievement_pictures.split(',')
        // 	}else{
        // 		item.achievement_pictures = []
        // 	}
        // 	this.ContentitemList.push(item)

        // })
        if ((res.data.result.achievement_pictures && res.data.result.achievement_pictures.length > 0)||(res.data.result.other_file && res.data.result.other_file.length > 0)) {
          // this.itemImgList = res.data.achievement_pictures.split(',')
          let imglist = res.data.result.achievement_pictures.concat(res.data.other_file)
          console.log(imglist, '111')
          imglist.map((item, index) => {
            if (item.name.indexOf('.png') != -1 || item.name.indexOf('.jpg') != -1 || item.name.indexOf('.jpeg') != -1) {
              // this.itemImgList.push(item)
              res.data.result.achievement_pictures.push(item)
              console.log(this.itemImgList, 'png')
            }
          })
        }

        this.ContentitemList = res.data.result
      }

    },
    // 通知公告
    async informationLists() {
      let obj = {show_position:2}
      let res = await informationList(obj)
      if (res.code == '00000') {
        this.informationList = res.data.result
      }

    },
    // 商家名录
    async enterpriseLists() {
      let res = await enterpriseList()
      if (res.code == '00000') {
        this.enterpriseList = res.data.result
      }
    },
    // 推介会
    async PromotionMeetings() {
      let obj = {
        type: 5
      }
      let res = await GetlistinformationInterface(obj)
      if (res.code == "00000") {
        this.PromotionMeeting = res.data.result
      }
    },

    // table 2的倍数行变色
    tableRowClassName({
                        row,
                        rowIndex
                      }) {
      if (rowIndex % 2 != 0) {
        return 'warning-row';
      }
      return '';
    },
    // 点击查看更多 跳转页面
    AchievementsMores(val) {
      // 成果转化
      if (val == 'conversion') {
        this.$router.push({
          path: './achievementListMorePage'
        })
      } else if (val == 'notice') {
        this.$router.push({
          path: './informationListMorePage'
        })
      } else if (val == 'Recommend') {
        this.$router.push({
          path: './PromotionMeetingsMorePage'
        })
      } else if (val == 'business') {
        this.$router.push({
          path: './enterpriseListMorePage'
        })
      }
    },
    openDetails(row) {
      this.AchievementsDetails({
        path: 'Recommend',
        item: row
      })
    },
    // 点击查看详情 跳转页面
    AchievementsDetails(val) {
      // 成果转化
      if (val.path == 'conversion') {
        this.$router.push({
          path: './achievementDetail',
          query: {
            type: val.item.ip_type,
            ids: val.item.id
          }
        })
      } else if (val.path == 'notice') {
        this.$router.push({
          path: './enterpriseDetail',
          query: {
            type: val.item.ip_type,
            ids: val.item.id
          }
        })
      } else if (val.path == 'Recommend') {
        this.$router.push({
          path: './informationDetail',
          query: {
            type: val.item.ip_type,
            ids: val.item.id
          }
        })
      } else if (val.path == 'business') {
        this.$router.push({
          path: './PromotionDetail',
          query: {
            type: val.item.ip_type,
            ids: val.item.id
          }
        })
      }
    }
  }

}
</script>

<style scoped="scoped" lang="less">
.bigbox {
  width: 63vw;
  margin: 0 auto;
  // border: 1px red solid;
}

.nav {
  margin-top: 14px;
  font-size: 1rem;
  color: #333333;
}

.newtopbox {

  display: flex;
  border: 1px solid #E5E5E5;

}

.newtopboxLeft {
  width: 37vw;
}

.newtopboxright {
  flex: 1;
  width: 10vw;
  // background: red;
  // border: 1px red solid;
  border-left: 1px solid #E5E5E5;

  div {
    height: calc(100%/2);
    width: 100%;
  }
}

.newtopboxright>div:nth-child(1) {
  background: red;
}

.newtopboxright>div:nth-child(2) {
  background: green;
}
.newtopboxrighttop{
  border-bottom:1px solid #E5E5E5;
  div{
    //padding-left: 10px;
    font-weight: 500;
  }
}

.topbox {
  // display: flex;
  border-bottom: 1px solid #E5E5E5;
  // padding-bottom: 1vh;
  // margin-top: 1.3vh;
  height: 3.8vh;
  line-height: 3.8vh;
  color: #666666;
  font-size: 1.12rem;
  padding-left: 1vw;
  padding-right: 1vw;
  background: #F6F6F6;
  // opacity: 0.23;

  div {
    margin-right: 10px;
    // padding-bottom: 1vh;
    display: inline-block;
  }

  .divSelect {
    border-bottom: 2px #0F7C63 solid;
    font-weight: bold;
    color: #333333;

  }
}

.bodeContent {
  // border: 1px red solid;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  // width:calc(63vw + 24px);
  width: 37vw;
  margin-left: 0.5vw;
  height: 73.3vh;
  overflow: hidden;
}

.bodeContent .Contentitembox {
  // width: 31vw;
  height: 22.2vh;
  width: calc((100% - 1vw*3) / 3);
  margin-right: 1vw;
  margin-top: 1.8vh;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  overflow: hidden;
}

.Contentitemboximg {
  width: 95%;
  margin: 0 auto;
  height: 10.8vh;
  background: #CCCCCC;
  margin-top: 0.5vh;

  img {
    width: 100%;
    height: 100%;
  }
}

.ContentitemboxText {
  width: 95%;
  margin: 0 auto;
  font-size: 0.87rem;
  overflow: hidden;

  div {
    margin-top: 0.6vh;
    color: #333333;
  }


}

.ContentitemboxText_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 1.2vh;
}

.ContentitemboxBottom {
  color: #666666;
  font-size: 0.75;
  float: right;
  margin-right: 1vw;
}

.ContentitemboxBottom:hover {
  color: #F05B23;
}

.bigitembox {
  width: 100%;
  // height: 27vh;
  margin-right: 24px;
  margin-top: 1.8vh;
  background: #FFFFFF;
  // box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.07);
  // border-radius: 5px;
  overflow: hidden;
}


.bodeContent:after {
  content: "";
  flex: auto;
}




.itemtop {
  height: 3.6vh;
  width: 100%;
  // border: 1px red solid;
  display: flex;
  justify-content: space-between;
  line-height: 3.6vh;
  // text-align: center;

}

.itemtop .left {
  width: 7.6vw;
  background: url(../../assets/chengguo/编组 12.png) no-repeat center;
  background-size: 100% 100%;
  color: #333333;
  font-size: 1rem;

  img {
    height: 54%;
    vertical-align: middle;
    margin-left: 3%;
    margin-right: 10%;
  }
}

.itemtop .right {
  margin-right: 3%;
  color: #333333;
  font-size: 0.87rem;
}

/deep/.el-table__header th {
  padding: 0;
  line-height: 3.9vh;
  height: 3.9vh;
  background: #F9F9F9;
  font-weight: bold;
  color: #666666;
  font-size: 0.88rem;

}

/deep/ .el-table__body td {
  padding: 0;
  height: 3.9vh;
  line-height: 3.9vh;
  color: #666666;
  font-size: 0.88rem;
}

/deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #005E3A;
  color: #FFFFFF;
}


/deep/.el-table .warning-row {
  background: #F9F9F9;
}

/deep/.el-table .success-row {
  background: #f0f9eb;
}

/*第一部分*/
.bodybox_modular {
  /*display: flex;*/
}

.bodybox_modular>div {
  /*margin-right: 22px;*/
  /*background: #FFFFFF;*/
  display: flex;
  // margin-top: 10px;
}

.hrrs {
  height: 1px;
  background: #E5E5E5;
  margin-top: 2vh;
  margin-bottom: 2vh;

}

.bodybox_modular>div>.bodybox_modular_bg {
  width: 16.6vw;
  height: 16vh;
  background: #D8D8D8;
  border-radius: 5px;

  img {
    width: 100%;
    height: 100%;
  }
}



.bodybox_modular>div>.bodybox_modular_box {
  width: 40.7vw;
  margin-left: 15px;
  position: relative;
  flex: 1;

}

.bodybox_modular>div .bodybox_modular_tx {
  padding-left: 10px;
  margin-top: 5px;
  // text-indent: 15px;
  color: #666666;
  font-size: 0.87rem;
}

.bodybox_modular>div .bodybox_modular_go {
  font-size: 0.87rem;
  float: right;
  margin-right: 5px;
  margin-top: 3px;
  color: #333333;

}



.bodybox_modular>div p {
  color: #333333;
  padding-left: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: #333333;
  line-height: 21px;
}


/deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
  cursor:pointer !important;
}
</style>
